var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingaporeToto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.912 68.412h72.986l13.191-36.824H20.102z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.677 64.604h70.141l10.461-29.208H20.138zm11.106-30.993h70.132l.398-1.104H21.171zM8.643 67.493h70.141l.406-1.149H9.05z",
    fill: "#cd043c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.018 65.011h6.193l7.315-20.974h5.009l3.154-9.056h-16.22l-3.154 9.056h5.009zM20.314 44.036h5.018L18.025 65.01h6.193l7.307-20.974h5.018l3.154-9.056h-16.23zm27.335-9.056c-4.391 0-10.293 6.723-13.191 15.019-2.889 8.296-1.67 15.019 2.721 15.019S47.482 58.296 50.371 50s1.67-15.019-2.721-15.019zm-2.43 14.878c-1.122 3.216-3.26 5.822-4.78 5.822s-1.847-2.606-.724-5.822 3.269-5.822 4.78-5.822c1.52 0 1.847 2.606.724 5.822zm34.43-14.878c-4.391 0-10.293 6.723-13.191 15.019-2.889 8.296-1.67 15.019 2.721 15.019S79.473 58.296 82.363 50c2.898-8.296 1.679-15.019-2.712-15.019zm-2.421 14.878c-1.122 3.216-3.26 5.822-4.789 5.822-1.52 0-1.847-2.606-.724-5.822s3.269-5.822 4.789-5.822c1.511 0 1.838 2.606.724 5.822z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingaporeToto);
export default __webpack_public_path__ + "static/media/singapore_toto.59e8fc3a52787504589bfdaa0cd4e255.svg";
export { ForwardRef as ReactComponent };